import { getEbscoSearch } from "features/News/services/ebsco.service";
import { getFilterDateValueKeys } from "utils/date-filter.util";
import { searchConfig } from "config";

const createEbscoAdapter = ({ searchContext }) => {
  const { currentSearchTerm, currentTimeframe, startDate, endDate } = searchContext;

  const pageSize = searchConfig.ebsco.count;
  const enabled = Boolean(currentSearchTerm);
  const dependencies = [currentSearchTerm, currentTimeframe, startDate, endDate];

  const fetchPage = async (page) => {
    if (!enabled) return { items: [], nextCursor: page, hasMore: false };
    const filteredDateValue = getFilterDateValueKeys(currentTimeframe, startDate, endDate);
    const data = await getEbscoSearch(currentSearchTerm, filteredDateValue, page, pageSize);
    const items = data?.webPages?.value || [];
    const total = data?.webPages?.totalEstimatedMatches || 0;
    const hasMore = page * pageSize < total;
    return { items, nextCursor: page + 1, hasMore };
  };

  return {
    idKey: "url",
    initialCursor: 1, // ebsco is page-based
    fetchPage,
    dependencies,
    enabled,
    isPageMode: true,
  };
};

export default createEbscoAdapter;
